import React from 'react';
import styled from 'styled-components';
import { margin, position } from 'styled-system';

import PurpleAngleLongLeft from 'assets/marketing/dutchie-plus/purple-angle-long-left';
import PurpleAngleShortLeft from 'assets/marketing/dutchie-plus/purple-angle-short-left';
import PurpleAngleLongRight from 'assets/marketing/dutchie-plus/purple-angle-long-right';
import PurpleAngleShortRight from 'assets/marketing/dutchie-plus/purple-angle-short-right';
import Header from './sections/header';

export default function DutchiePlusMarketing() {
  return (
    <PageWrapper>
      <Container>
        <SectionContainer>
          <Header />
        </SectionContainer>
        <Angles top='unset' bottom={0}>
          <AngleContainer top={['43%', null, '8em']} mobilePosition='-10px'>
            <PurpleAngleLongLeft />
            <PurpleAngleShortLeft />
          </AngleContainer>
          <AngleContainer bottom={['0', '-10px']} right={0} svgRight='0' noMargin mobilePosition='-10px'>
            <PurpleAngleLongRight />
            <PurpleAngleShortRight />
          </AngleContainer>
        </Angles>
      </Container>
    </PageWrapper>
  );
}

const SectionContainer = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  max-width: 1440px;
  margin: 0 auto;
`;

const Angles = styled.div`
  position: absolute;
  z-index: 10;
  height: 300px;
  width: 100%;
  display: flex;
  flex: 1;
  ${position};
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    height: 120px;
    ${({ mobileTop }) => mobileTop && `top: ${mobileTop}px !important;`};
  }
`;

const AngleContainer = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  ${margin};
  ${position};
  &:nth-child(even) {
    bottom: 128px;
    ${position};
    ${({ theme }) => theme.breakpoints.down(`sm`)} {
      bottom: 34px;
      ${({ mobilePosition }) => mobilePosition && `bottom: ${mobilePosition} !important;`};
    }
  }
  svg {
    position: absolute;
    right: ${({ svgRight }) => svgRight || `unset`};
    height: 100%;
    width: 60%;
    flex: 0 60%;
    &:nth-child(even) {
      top: -10%;
    }
  }
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    ${position};
  }
  ${({ theme }) => theme.breakpoints.up(`xl`)} {
    svg {
      width: auto;
    }
  }
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  margin-bottom: 200px;
  background: ${({ theme }) => theme.colors.dutchiePlusBlue[10]};
  &:after {
    border-color: transparent transparent ${({ theme }) => theme.colors.white} transparent;
    border-style: solid;
    border-width: 0 0 242px 100vw;
    bottom: -1px;
    content: '';
    height: 0;
    position: absolute;
    left: 0;
    width: 0;
    overflow: auto;
  }
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    margin-bottom: 100px;
    &:after {
      border-width: 0 0 80px 100vw;
    }
  }
`;

const PageWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
`;
